import { createTraitsSelector } from '@atlassian/jira-traits/src/TraitsStore.tsx';

export const useIsOptoutAllMessagesSite = createTraitsSelector<'SITE'>(
	'SITE',
	({ getTraitByName }) => {
		const optoutAllMessages = getTraitByName('optout_all_messages')?.value;
		return typeof optoutAllMessages === 'boolean' && optoutAllMessages;
	},
);

export const useIsOptoutAllMessagesSiteUser = createTraitsSelector<'SITE_USER'>(
	'SITE_USER',
	({ getTraitByName }) => {
		const optoutAllMessages = getTraitByName('optout_all_messages_user')?.value;
		return typeof optoutAllMessages === 'boolean' && optoutAllMessages;
	},
);
